import Img from './Img'
import { TYPES } from '../const'

export default class Video extends Img {
	protected readonly type = TYPES.VIDEO
	protected readonly mode: 'landscape' | 'portrait'
	private readonly videoNode: HTMLVideoElement
	private readonly canvas: HTMLCanvasElement
	private readonly ctx: CanvasRenderingContext2D
	private hasCheckedSupport = false
	private hasVideoSupport = false

	constructor(params) {
		super(params)
		this.mode = params.mode
		this.sizing = params.sizing || 'cover'
		this.imgNode = params.node.querySelector(`.js-poster`)
		this.videoNode = params.node.querySelector(`.js-video-${this.mode}`)
		this.videoNode.src = this.videoNode.dataset.src
		this.canvas = document.createElement('canvas');
		this.ctx = this.canvas.getContext('2d');

	}

	async animateIn(forward) {
		await super.animateIn(forward)
		this.playVideo()
	}

	async animateOut(forward) {
		await super.animateOut(forward)
		if (this.hasVideoSupport) this.videoNode.pause()
	}

	playVideo() {
		if (this.hasCheckedSupport) {
			if (this.hasVideoSupport) this.videoNode.play()
		} else {
			this.checkSupport()
		}
	}

	async checkSupport() {
		await this.videoNode.play()
		// no autoplay on mobile
		this.hasVideoSupport = !this.videoNode.paused
		this.hasCheckedSupport = true
	}

	draw(gl) {
		if (!this.visible) return

		gl.useProgram(this.program)
		gl.activeTexture(gl.TEXTURE0)
		gl.bindTexture(gl.TEXTURE_2D, this.texture)

		if (this.hasVideoSupport && this.videoNode.readyState >= this.videoNode.HAVE_CURRENT_DATA) {
			this.canvas.width = this.videoNode.videoWidth;
			this.canvas.height = this.videoNode.videoHeight;
			this.ctx.drawImage(this.videoNode, 0, 0);
			gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, this.canvas)
		}

		super.setAttributesAndUniforms(gl)

		gl.drawArrays(gl.TRIANGLES, 0, this.len)
	}
}
